import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=578a9c64&scoped=true"
import script from "./Return.vue?vue&type=script&lang=ts"
export * from "./Return.vue?vue&type=script&lang=ts"
import style0 from "./Return.vue?vue&type=style&index=0&id=578a9c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a9c64",
  null
  
)

export default component.exports